export default {
  staleImageError: {
    title: 'Veralteter Frame',
    description: 'Das Kamerabild ist veraltet (veraltet)',
  },
};
